<template>
  <div class="w-100">
    <div class="container-fluid px-0">
      <div class="row align-items-center mb-3 mx-0">
        <div class="col-12 col-lg-6 text-left px-0">
          <div
            class="w-100 d-flex align-items-center justify-content-between justify-content-lg-start"
          >
            <span class="carousel_title_new">⁠Live TV</span>
            <!-- <div
              class="d-flex flex-row align-items-center ml-3 view-all-wrapper"
              @click="viewMore()"
            >
              <span class="see-more-text cursor-pointer">View All</span>
            </div> -->
          </div>
        </div>
      </div>
      <div class="row mx-0 latest-tv-rails-content" id="homepageTVCarousel">
        <div class="w-100">
          <div class="owl-carousel owl-theme" id="latesthomepagetv">
            <a
              class="item-list mx-2 mt-3 mx-lg-0 mt-lg-0 mb-lg-4 cursor-pointer"
              v-bind:class="{ active: player_id === item.id }"
              v-for="item in live_tv"
              :key="item.id"
              :href="
                $router.resolve({ path: '/live/' + getSlug(item.id) }).href
              "
            >
              <div
                class="main-item-wrapper d-flex flex-column position-relative"
              >
                <div class="item_img">
                  <img
                    v-bind:src="item.img_link"
                    @error="imageLoadError($event)"
                    class="img-class"
                  />
                  <div class="live-tag" v-if="item.data.customStatus == 'live'">
                    <div class="mr-1">
                      <img src="@/assets/icon/live.png" class="live-tag-img" />
                    </div>
                    <div class="d-flex align-items-center">
                      <span class="latest-text">LIVE</span>
                    </div>
                  </div>
                </div>
                <div class="now-playing-div" v-if="player_id === item.id">
                  <p class="mb-0 now-playing-title">Now Playing</p>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import radioCard from "../cards/radioCard.vue";
export default {
  data: function() {
    return {
      live_tv: [],
      exclude_id: 3902,
    };
  },
  props: ["active_id"],
  components: { radioCard },
  created: function() {
    this.$store.dispatch("fetchLiveTV", { self: this });
  },
  methods: {
    viewMore() {
      this.$router.push("/radio/");
    },
    filterLiveTv() {
      var vm = this;

      var tv_order = [2, 3391, 1229];

      var data = vm.$store.state.live_tv.data;

      data.sort(function(a, b) {
        return tv_order.indexOf(a.id) - tv_order.indexOf(b.id);
      });

      vm.live_tv = data;
      // console.log(JSON.stringify(vm.live_tv, null, 2));

      var store = [];
      vm.live_tv.forEach((item) => {
        if (item.id != vm.exclude_id) {
          item["img_link"] = vm.imgFiltering(item);
          store.push(item);
        }
      });

      vm.live_tv = store;

      Vue.nextTick(
        function() {
          vm.installOwlCarousel("#latesthomepagetv");
        }.bind(vm)
      );
    },

    getSlug(id) {
      var slug;
      if (id == 2) {
        slug = "SUKMAINDERA";
      } else if (id == 3391) {
        slug = "ANEKA";
      } else if (id == 1229) {
        slug = "GOLIVE";
      }

      return slug;
    },
    itemClick(item) {
      var slug;
      if (item.id == 2) {
        slug = "SUKMAINDERA";
      } else if (item.id == 3391) {
        slug = "ANEKA";
      } else if (item.id == 1229) {
        slug = "GOLIVE";
      }

      this.$router.resolve({ path: "/live/" + slug }).href;
    },

    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 4,
        autoplay: false,
        loop: false,
        nav: false,
        dots: false,
        stagePadding: 0,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-md"></span>',
          '<span class="fa fa-chevron-right fa-md"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            this.loop = false;
          }
        },
        responsive: {
          0: {
            items: 2,
            nav: false,
            margin: 8,
            stagePadding: 4,
          },
          768: {
            items: 4,
            stagePadding: 0,
            loop: false,
            margin: 16,
            nav: true,
          },
        },
      });
    },
  },
};
</script>

<style>
.latest-tv-rails-content .owl-theme .owl-stage-outer {
  overflow: unset;
}

#homepageTVCarousel .owl-nav {
  display: none;
}

button:focus {
  outline: unset !important;
}

@media only screen and (min-width: 992px) {
  #homepageTVCarousel .owl-theme:hover {
    z-index: 111;
  }

  #homepageTVCarousel .owl-theme {
    height: auto;
  }
  #homepageTVCarousel .owl-item {
    z-index: 1;
  }
  #homepageTVCarousel .owl-item:hover {
    transition: 0.1s all ease-in-out;
    width: 100%;
    z-index: 2000;
  }

  #homepageTVCarousel .owl-theme .owl-nav.disabled {
    display: none !important;
  }
  #homepageTVCarousel .owl-theme .owl-nav {
    position: absolute;
    top: -64px;
    right: 2px;
    width: 80px;
    display: flex;
    justify-content: space-between;
    z-index: 11;
  }

  #homepageTVCarousel .owl-prev {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px 0 0;
    z-index: 1;
  }

  #homepageTVCarousel .owl-next {
    width: 40px !important;
    height: 36px !important;
    background-color: #fab913;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    z-index: 1;
  }

  #homepageTVCarousel .owl-next span,
  #homepageTVCarousel .owl-prev span {
    color: rgb(0, 0, 0) !important;
  }
}
</style>

<style scoped>
.min-height-for-section {
  /* min-height: 100vh; */
  padding-bottom: 80px;
}
.cursor-pointer {
  cursor: pointer;
}
.pt-livetv {
  padding-top: 20px;
}
.item_img {
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
  padding-top: 56.25%;
  z-index: 20;
  background: #eae7e5;
}
.item_img .img-class {
  background: 100%;
  width: 100%;
  height: auto;
  overflow: hidden;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  position: absolute;
}
.item-list {
  width: 100% !important;
}
.live-tag {
  position: absolute;
  top: 6px;
  left: 6px;
  padding: 2px 5px;
  background: #ff0000;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: row;
  align-items: center;
}
.live-tag .live-tag-img {
  width: 16px;
}
.latest-text {
  font-size: 12px;
  font-weight: bold;
  line-height: 1.14;
  text-align: left;
  color: #ffffff;
}
.title {
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
  color: #fab92b;
  font-family: "Poppins", sans-serif !important;
}
.slogan {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  color: #fff;
  font-family: "Poppins", sans-serif !important;
}
.small-logo {
  width: 82px;
  border-radius: 8px;
  overflow: hidden;
}
.active {
  position: relative;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  width: 100%;
  border: 3px solid #fab900;
}
.now-playing-div {
  padding: 4px 10px;
  background: #f9b91b;
  position: absolute;
  bottom: 0;
  right: 0;
  border-top-left-radius: 4px;
  display: flex;
  align-items: center;
}
.now-playing-title {
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  color: #292929;
  padding-top: 2px;
}
.sharebtndiv {
  cursor: pointer;
}
.sharebtndiv span {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.19;
  color: #facb43;
  font-family: "Poppins", sans-serif !important;
}
.sharebtndiv img {
  width: 20px;
}

@media only screen and (max-width: 992px) {
  .item-list {
    width: 45% !important;
  }

  .min-height-for-section {
    padding-bottom: 40px;
  }
  .list-div {
    max-width: 100%;
    margin: 0 auto;
  }
  .active::before {
    content: "";
    display: none;
  }
}

@media only screen and (max-width: 768px) {
  .min-height-for-section {
    min-height: 70vh;
  }
  .pt-livetv {
    padding-top: 20px;
  }

  .live-tag {
    padding: 2px 4px;
    height: 16px;
  }
  .live-tag .live-tag-img {
    width: 12px;
  }
  .latest-text {
    font-size: 10px;
  }
  .title,
  .now-playing-title,
  .sharebtndiv span {
    font-size: 12px;
  }
  .small-logo {
    width: 42px;
  }
}
@media only screen and (max-width: 480px) {
  .active::before {
    display: none;
  }
  .sharebtndiv img {
    width: 16px;
  }
}

.carousel_title_new {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(250, 185, 19, 1);
}
.view-all-wrapper {
  border-radius: 8px;
  background: rgba(250, 185, 19, 1);
  padding: 6px 12px;
}
.see-more-text {
  font-family: "Poppins", sans-serif !important;
  font-weight: 700;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 1);
}

@media only screen and (max-width: 768px) {
  .carousel_title_new {
    font-size: 18px;
    line-height: 22px;
  }
  .see-more-text {
    font-size: 14px;
    line-height: 22px;
  }
}
</style>
